export default "__VITE_ASSET__JAo3y_58__"